import React from 'react';
import Container from 'components/container';
import PublicLayout from 'components/layouts/Public';
import { BLOG_URL } from 'constants/urls';
import { BlogPost } from 'containers/blog';
import { blogPostFeedItems, getBlogPost } from 'content/blog';
import { useStaticRouter } from 'utils/useStaticRouter';

const BlogPostPage = () => {
  const router = useStaticRouter();
  const { id } = router.query;

  return (
    <PublicLayout>
      <Container centerContent py="20px" pylg="20px">
        {id && <BlogPost id={id as string} getBlogPost={getBlogPost} path={BLOG_URL} />}
      </Container>
    </PublicLayout>
  );
};

export const getStaticPaths = async () => {
  return {
    paths: blogPostFeedItems.map(({ id }) => ({ params: { id } })),
    fallback: true,
  };
};

export const getStaticProps = async () => {
  return { props: {} };
};

export default BlogPostPage;
